import { FieldWrapper as ToolkitFieldWrapper } from '@mlc/web-ui-toolkit';
import styled from 'styled-components';
import { ScreenSize } from '../../../../enums';

export const EmptyDiv = styled.div`
	margin-left: '20px';
	max-width: '40px';
	text-align: 'right';
`;

export const FieldWrapper = styled(ToolkitFieldWrapper)`
	@media (min-width: ${ScreenSize.small}) {
		width: 350px;
	}

	width: inherit;
`;
